import { DiagnosticAssessmentTableFilters } from '../components/AssessmentHistory/models';
import { DiagnosticModalTableFilters } from '../components/AssessmentHistory/ResetAndOutstandingDiagnosticModalWrapper';
import { SkillAssessmentTableFilters } from '../components/AssessmentHistory/SkillAssessmentTable';
import { ReportData } from '../models/Report';

export const mergeDiagnosticAssessmentsHistoryFilters = (
  first: DiagnosticAssessmentTableFilters,
  second: ReportData,
) => {
  return {
    ...first,
    filters: {
      ...first.filters,
      roadmaps: second.roadmap ? [second.roadmap] : first.filters.roadmaps,
      classes: second.classes ? second.classes : first.filters.classes,
    },
  };
};

export const mergeProgressSkillsAssessmentsHistoryFilters = (
  first: SkillAssessmentTableFilters,
  second: ReportData,
) => {
  return {
    ...first,
    filters: {
      ...first.filters,
      roadmaps: second.roadmap ? [second.roadmap] : first.filters.roadmaps,
      classes: second.classes ? second.classes : first.filters.classes,
    },
  };
};

export const mergeDiagnosticOustandingFilters = (first: DiagnosticModalTableFilters, second: ReportData) => {
  return {
    ...first,
    filters: {
      ...first.filters,
      classes: second.classes ? second.classes : first.filters.classes,
    },
  };
};
